module.exports = __webpack_public_path__ + "static/media/oralB.3e05145d.png";